import React, { useContext, useEffect, useState } from "react";
import "admin-lte/dist/css/adminlte.min.css";
import "../../../assets/AdminCss/dashboard.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faCaretLeft } from "@fortawesome/free-solid-svg-icons";

import { Link, useLocation, useNavigate } from "react-router-dom";
import { AuthContext, base_url } from "../../../context/Authcontext";
import axios from "axios";
import api from "../../../utils/api";
// import axios from "axios";
// import { base_url } from "./AdminUsers";


const AdminSidebar = ({ isSidebarOpen, toggleSidebar, isMobile }) => {
  const navigate = useNavigate();
  const [key, setKey] = useState({ name: '', role: '' });
  const [isPagesOpen, setIsPagesOpen] = useState({});
  const { getRoles } = useContext(AuthContext);
  const location = useLocation();
  const [sideListItems, setSideListItems] = useState(
    [
      {
        Name: 'Home',
        url: "/admin/home",
        iconName: "nav-icon fa fa-home",
        isAllowed: false
      },
      {
        Name: 'User',
        iconName: "nav-icon fa fa-user",
        List: [],
        isAllowed: false
      },
      // {
      //   Name: "Pending Recharge",
      //   url: "/admin/browse_recharge",
      //   iconName: "nav-icon fa fa-credit-card",
      //   isAllowed: false,
      // },
      // {
      //   Name: "Pending Withdraw",
      //   url: "/admin/browse_withdrawl",
      //   iconName: "nav-icon fa fa-bank",
      //   isAllowed: false,
      // },
      // {
      //   Name: "Deposit History",
      //   url: "/admin/deposit_history",
      //   iconName: "nav-icon fa fa-history",
      //   isAllowed: false,
      // },
      // {
      //   Name: "Withdraw History",
      //   url: "/admin/withdraw_history",
      //   iconName: "nav-icon fa fa-history",
      //   isAllowed: false,
      // },
      // {
      //   Name: "Sports",
      //   url: "#",
      //   iconName: "nav-icon fa fa-futbol",
      //   isAllowed: false,
      // },
      {
        Name: "Add Matches",
        url: "/admin/matches",
        iconName: "nav-icon fa fa-calendar",
        isAllowed: false,
      },
      // {
      //   Name: "Market Analysis",
      //   url: "/admin/marketAnalysis",
      //   iconName: "nav-icon fa fa-calendar",
      //   isAllowed: false,
      // },
      // {
      //   Name: "Matches-history",
      //   url: "/admin/matches_history",
      //   iconName: "nav-icon fa fa-history",
      //   isAllowed: false,
      // },
      {
        Name: "Manage Sports Results",
        url: "/admin/manage_market",
        iconName: "nav-icon fa fa-sliders",
        isAllowed: false,
      },
      // {
      //   Name: "My Market",
      //   url: "/admin/my_market",
      //   iconName: "nav-icon fa fa-briefcase", 
      //   isAllowed: false,
      // },
      // {
      //   Name: "Manage Fancy",
      //   url: "/admin/manage_fancy",
      //   iconName: "nav-icon fa fa-cogs",   
      //   isAllowed: false,
      // },
      // {
      //   Name: "Fancy History",
      //   url: "/admin/fancy_history",
      //   iconName: "nav-icon fa fa-history",
      //   isAllowed: false,
      // },
      {
        Name: "Casino-history",
        url: "/admin/casinohistory",
        iconName: "nav-icon fa fa-dice",
        isAllowed: false,
      },
      {
        Name: "Slider",
        url: "/admin/slider",
        iconName: "nav-icon fa fa-image",
        isAllowed: false,
      },
      // {
      //   Name: "Bonus",
      //   url: "/admin/bonus",
      //   iconName: "nav-icon fa fa-gift",
      //   isAllowed: false,
      // },

      //  {
      //   Name: "Promo Code",
      //   url: "/admin/promocode",
      //   iconName: "nav-icon fa fa-user-plus",
      //   isAllowed: false,
      // },
      // {
      //   Name: "Admin Bonus",
      //   url: "/admin/adminbonus",
      //   iconName: "nav-icon fa fa-user-plus",
      //   isAllowed: false,
      // },
      {
        Name: "Settlement",
        url: "/admin/settlement",
        iconName: "nav-icon fa fa-gift",
        isAllowed: false,
      },
      {
        Name: "Roles",
        url: "/admin/roles",
        iconName: "nav-icon fa fa-users-cog",
        isAllowed: false,
      },
      {
        Name: "Delete Bets",
        url: "/admin/getDeleteBets",
        iconName: "nav-icon fa fa-trash",
        isAllowed: false,
      },
      {
        Name: "Reports",
        iconName: "nav-icon fa fa-chart-bar",
        List: [
          {
            Name: "My Bets",
            url: "/admin/betHistory",
            iconName: "nav-icon fa fa-list-alt", 
            isAllowed: false
          },
          {
            Name: "Match History",
            url: "/admin/matchHistoryManage",
            iconName: "nav-icon fa fa-line-chart", 
            isAllowed: false
          },
          {
            Name: "settlement history",
            url: "/admin/settleHistory",
            iconName: "nav-icon fa fa-balance-scale", 
            isAllowed: false
          },
          {
            Name: "Profit Loss",
            url: "/admin/profitloss",
            iconName: "nav-icon fa fa-line-chart", 
            isAllowed: false
          },

          {
            Name: "Super Admin Chip",
            url: "/admin/adminChip",
            iconName: "nav-icon fa fa-diamond",
            isAllowed: false
          },
          {
            Name: "User Chip",
            url: "/admin/userChip",
            iconName: "nav-icon fa fa-circle", // Represents token or chip
            isAllowed: false
          },
          // {
          //   Name: "Commission History",
          //   url: "/admin/commissionHistory",
          //   iconName: "nav-icon fa fa-percent", // Represents commission/percentage
          //   isAllowed: false
          // },
          {
            Name: "week-report",
            url: "/admin/weekReport",
            iconName: "nav-icon fa fa-calendar", // Represents time period/report
            isAllowed: false
          },
          {
            Name: "Fancy History",
            url: "/admin/fancyHistory",
            iconName: "nav-icon fa fa-history", // Represents records/lists
            isAllowed: false
          },
        ],

        isAllowed: false,
      },
      {
        Name: "Settings",
        url: "/admin/settings",
        iconName: "nav-icon fa fa-cog",
        isAllowed: false,
      },
    ]
  );


  const handleLogout = () => {
    navigate("/admin/login");
    localStorage.removeItem("admin");
  };

  const fetchUser = async (req, res) => {
    const auth = localStorage.getItem('admin');

    try {

      const response = await api.get("/api/webapi/loggedUser",
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${auth}`
          }
        }
      )
      // console.log('prr',response);
      const name = response.data.username.username;
      const role = response?.data.username.role;
      setKey({ name: name, role: role });
      // console.log('reps',response.data.username.username);

    } catch (err) {
      console.log('err', err);
    }
  }

  const handleClick = (list) => {

    if (list.url) {
      navigate(list.url);

    } else if (list.List) {
      setIsPagesOpen((prev) => ({
        ...prev,
        [list.Name]: !prev[list.Name]
      }))
    }

  };

  const fetchRoles = async () => {
    const auth = localStorage.getItem('admin');
    const role = localStorage.getItem('role');

    try {
      const roles = await getRoles(auth, role);
      const permitRole = roles[0];
      const key = Object.keys(permitRole);
      setKey(key[0]);
      const arr = permitRole[key];
      const allowedKeys = []
      const allowedValues = []

      arr.map(item => {
        const k = Object.keys(item);
        const valuess = Object.values(item);

        allowedKeys.push(k[0]);
        allowedValues.push(valuess[0]);
      })

      const allowed = []

      allowedValues.forEach(allow =>
        allow.forEach(values => allowed.push(values.toLowerCase()))
      );

      setSideListItems((prevItems) =>
        prevItems.map((item) => ({
          ...item,
          isAllowed: allowedKeys.includes(item.Name.toLowerCase()),

          List: item.List
            ? item.List.map((subItem) => ({
              ...subItem,
              isAllowed: allowed.includes(subItem.Name.toLowerCase()),
            }))
            : item.List,
        }))
      );


    } catch (err) {
      console.log('erd', err);
    }
  }

  const roleName = async (req, res) => {
    const auth = localStorage.getItem('admin');

    try {
      const response = await api.post('/api/webapi/admin/Rolelist',
        {},
        {
          headers: {
            Accept: 'application/json',
            Authorization: `${auth}`
          }
        }
      )

      const fullRoles = response.data.data;

      let arr = [];

      fullRoles?.map(full => {
        const keyy = Object.keys(full);

        arr.push(keyy[0]);
        // console.log('kuyy',keyy[0]);
      });

      return arr;

    } catch (err) {
      console.log('err', err);
    }
  }

  const updateSidebarWithRoles = (roleNames) => {
    const roleHierarchy = [
      "Super admin",
      "Admin",
      "Super master",
      "Master",
      "Agent",
      "User"
    ];

    const normalRoles = roleNames.map(role => role.toLowerCase());


    const hierarchy = roleHierarchy.map(role => role.toLowerCase());


    const verified = hierarchy.filter(hier => normalRoles.includes(hier));
    setSideListItems(prevItems => {
      return prevItems?.map(item => {
        if (item.Name === 'User') {
          return {
            ...item,
            List: verified.map(itemName => ({
              Name: itemName,
              url: `/admin/${itemName.toLowerCase().replace(/\s+/g, '')}`,
              isAllowed: false
            }))
          };
        }
        return item;
      });
    });
  };

  useEffect(() => {
    const initializeSidebar = async () => {
      try {
        const roleNames = await roleName();
        updateSidebarWithRoles(roleNames);
        await fetchUser();
      } catch (error) {
        console.error("Error initializing sidebar:", error);
      }
    };

    initializeSidebar();
    fetchRoles();
  }, []);


  useEffect(() => {
    const currentPath = location.pathname;

    setSideListItems(prevItems => {
      const openPages = {};

      prevItems.forEach(item => {
        if (item.List) {
          const matched = item.List.some(sub => sub.url === currentPath);
          if (matched) {
            openPages[item.Name] = true;
          }
        }
      });

      setIsPagesOpen(openPages);
      return prevItems;
    });
  }, [location.pathname]);

  useEffect(() => {
    const currentPath = location.pathname;

    setIsPagesOpen((prevOpen) => {
      const updatedOpen = { ...prevOpen };

      sideListItems.forEach(item => {
        if (item.List) {
          const matched = item.List.some(sub => sub.url === currentPath);
          if (matched) {
            updatedOpen[item.Name] = true; 
          }
        }
      });

      return updatedOpen;
    });
  }, [location?.pathname, sideListItems]);


  return (
    <>
      {isMobile && isSidebarOpen && (
        <div
          className="sidebar-overlay"
          onClick={toggleSidebar}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            zIndex: 1040,
          }}
        />
      )}

      <aside
        className={`main-sidebar sidebar-light-primary fs-6 sidebar-scroll-hidden ${isSidebarOpen ? "sidebar-open" : "sidebar-collapse"
          }`}
        style={{
          zIndex: 1050,
          borderRight: "1px solid #14b09d",
          transition: "transform 0.3s ease-in-out",
          position: "fixed",
          height: "100%",
          overflowY: "auto",
          transform: window.innerWidth <= 768 && !isSidebarOpen ? "translateX(-100%)" : "translateX(0)",
          display: "none",
        }}
      >
        {/* Brand Logo */}
        <p className="brand-link align-items-center brand-link mb-0 pb-2 d-flex justify-content-start gap-3 ml-0 cursor-pointer" style={{ backgroundColor: "#f0fef9" }}>

          <Link
            data-target="nav-mobile"
            className="sidenav-trigger1"
            onClick={toggleSidebar}
          >
            <img
              src="/assets/images/Xcross.svg"
              alt="Close Menu"
              className="cross-icon"
            />
          </Link>


          <img src="/assets/images/avatar.svg" alt="" style={{ width: "40px" }} onClick={() => navigate('/admin/Profile')} />
          {isSidebarOpen && (
            <span className="brand-text font-weight-light text-wrap">
              {key.name} | {key.role}
            </span>
          )}
        </p>

        {/* Sidebar */}
        <div className="sidebar" style={{ height: "auto" }}>
          {/* Sidebar Menu */}
          <nav className="mt-2">
            <ul className="nav nav-pills nav-sidebar flex-column" role="menu">
              {/* Dashboard */}
              <li className={`nav-item ${location.pathname === "/admin/dashboard" ? "active-nav" : ""}`}
                onClick={() => navigate('/admin/dashboard')}>
                <Link to="#" className="align-items-center d-flex nav-link gap-2">
                  <i className={`nav-icon fa fa-home`} style={{ color: "#14b09d" }}></i>
                  {isSidebarOpen && <p>Dashboard</p>}
                </Link>
              </li>
              {sideListItems.map((list, index) => {
                return (
                  <li
                    key={index}
                    className={`nav-item ${list.isAllowed ? "d-block" : "d-none"} ${location.pathname === list.url ? "active-nav" : ""}`}
                    onClick={() => { handleClick(list) }}
                  >
                    <Link
                      to="#"
                      className="align-items-center d-flex nav-link gap-2"
                    >
                      <i className={`${list.iconName} fs-5`} style={{ color: "#14b09d" }}></i>
                      {isSidebarOpen && (
                        <p>{list.Name}</p>
                      )}
                      {list.Name === "Reports" && (
                        <FontAwesomeIcon
                          icon={isPagesOpen[list.Name] ? faCaretDown : faCaretLeft}
                          className="dropdown-icon ms-auto"
                        />
                      )}

                      {list.Name === "User" && (
                        <FontAwesomeIcon
                          icon={isPagesOpen[list.Name] ? faCaretDown : faCaretLeft}
                          className="dropdown-icon ms-auto"
                        />
                      )}

                    </Link>

                    {list.Name === "User" && isPagesOpen[list.Name] &&
                      list.List
                        .filter((uList) => uList.isAllowed)
                        .map((uList, id) => {
                          return (
                            <ul
                              key={id}
                              className={`nav nav-treeview ${isPagesOpen ? "show" : ""}`}
                            >
                              <li
                                className={`nav-item ${location.pathname === uList.url ? "active-nav" : ""}`}
                                onClick={(e) => {
                                  e.stopPropagation(); // 🔧 prevent parent li toggle
                                  navigate(`${uList.url}`);
                                }}
                              >
                                <Link
                                  to="#"
                                  className="align-items-center d-flex nav-link"
                                >
                                  <i className={`${uList.iconName} fs-6`}></i>
                                  <p>{uList.Name}</p>
                                </Link>
                              </li>
                            </ul>
                          );
                        })}

                    {list.Name === "Reports" && isPagesOpen[list.Name] &&
                      list.List
                        .filter((uList) => uList.isAllowed)
                        .map((uList, id) => {
                          return (
                            <ul
                              key={id}
                              className={`nav nav-treeview pl-3 ${isPagesOpen ? "show" : ""}`}
                            >
                              <li
                                className={`nav-item ${location.pathname === uList.url ? "active-nav" : ""}`}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigate(`${uList.url}`);
                                }}
                              >
                                <Link
                                  to="#"
                                  className="align-items-center d-flex nav-link"
                                >
                                  <i className={`${uList.iconName} fs-6`}></i>
                                  <p>{uList.Name}</p>
                                </Link>
                              </li>
                            </ul>
                          );
                        })}
                  </li>
                );
              })}
              <li className="nav-item" onClick={handleLogout}>
                <Link to="#" className="align-items-center d-flex nav-link gap-2">
                  <i className={`nav-icon fa fa-sign-out`}></i>
                  {isSidebarOpen && <p>Log Out</p>}
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </aside>
    </>
  );
};

export default AdminSidebar;
